export const REFRESH_DATA_INTERVAL_IN_MILISECONDS: number = 60000;